import { useFormikContext } from "formik";
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { setDisabledFields } from "../../../features/customer/customerSlice";
import { customerKindEnum, isExists } from "../../../utils";

// Turmob entegration start
export function setIndividualTurmob(values: any, setFieldValue: any) {
  setFieldValue("customerKindId", customerKindEnum.indivual);
  setFieldValue("name", values.ad);
  setFieldValue("surname", values.soyad);
  const year = values.kurulusTarihi.substring(0, 4);
  const month = values.kurulusTarihi.substring(4, 6);
  const day = values.kurulusTarihi.substring(6, 8);
  const dateOfBirth = new Date(`${year}-${month}-${day}`);
  setFieldValue("dateOfBirth", dateOfBirth);
  setFieldValue("contact.dateOfBirth", dateOfBirth);
}

export function setCorporateTurmob(values: any, setFieldValue: any) {
  setFieldValue("customerKindId", customerKindEnum.corporate);
  setFieldValue("commercialTitle", values.kimlikUnvani);
  setFieldValue("alias", values.unvan);
}

export function checkTurmobType(type: any, values: any, setFieldValue: any) {
  switch (type) {
    case "1":
      setIndividualTurmob(values, setFieldValue);

      break;
    case "7":
      setCorporateTurmob(values, setFieldValue);
      break;
  }
}

export function setTurmobAddress(address: any, setFieldValue: any) {
  if (address?.length > 0) {
    const fields = [
      "mahalleSemt",
      "koy",
      "caddeSokak",
      "disKapiNo",
      "icKapiNo",
      "beldeBucak",
      "ilceAdi",
      "ilAdi",
      "ilKodu",
      "ilceKodu",
    ];
    const addressInfo = address[0];

    let showAddress = "";
    fields.forEach((item) => {
      if (item === "disKapiNo" && isExists(addressInfo[item])) {
        showAddress += `Dış kapı no: ${addressInfo[item]}`;
      }
      if (item === "icKapiNo" && isExists(addressInfo[item])) {
        showAddress += `İç kapı no: ${addressInfo[item]}`;
      }
      if (isExists(addressInfo[item])) {
        showAddress += `${addressInfo[item]} `;
      }
    });
    if (isExists(showAddress)) {
      setFieldValue("address.detail", showAddress);
    }
  }
}

export function clearFields(setFieldValue: any) {
  setFieldValue("name", "");
  setFieldValue("surname", "");
  setFieldValue("dateOfBirth", new Date());
  setFieldValue("contact.dateOfBirth", new Date());
  setFieldValue("commercialTitle", "");
  setFieldValue("alias", "");
  setFieldValue("address.detail", "");
}

export function shouldBeStart(value: any) {
  if (value?.length === 10 || value?.length === 11) {
    return true;
  } else {
    return false;
  }
}

export const TurmobHandler = () => {
  const formik = useFormikContext();

  const { values, setFieldValue }: any = formik;
  const dispatch = useAppDispatch();
  const [turmob, setTurmob] = useState({ data: "", init: false });

  // Initialize turmob if true
  // if (shouldBeStart(values.citizenOrTaxNumber) && !turmob.init) {
  //   const result = await dispatch(
  //     ApiSlice.endpoints.getList.initiate({
  //       resource: `customer/turmob?vkntckn=${values.citizenOrTaxNumber}`,
  //     })
  //   );

  //   const { data }: any = result;

  //   if (data?.data?.durum.sonuc && !isExists(turmob.data)) {
  //     setTurmob({ data: data, init: true });
  //     const type = data.data.sirketinTuru;
  //     const address = data.data?.adresBilgileri;
  //     setTurmobAddress(address, setFieldValue);
  //     checkTurmobType(type, data.data, setFieldValue);
  //     if (type === "1") {
  //       dispatch(
  //         setDisabledFields({
  //           name: true,
  //           surname: true,
  //           commercialTitle: false,
  //           alias: false,
  //           isEInvoiceUser: true,
  //           dateOfBirth: true,
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         setDisabledFields({
  //           name: false,
  //           surname: false,
  //           commercialTitle: true,
  //           alias: true,
  //           isEInvoiceUser: true,
  //         })
  //       );
  //     }
  //   }
  // }

  // Set turmob false when tc is empty and turmob before start
  if (values.citizenOrTaxNumber?.length === 0 && turmob.init) {
    setTurmob({ data: "", init: false });
    clearFields(setFieldValue);
    dispatch(
      setDisabledFields({
        name: false,
        surname: false,
        commercialTitle: false,
        alias: false,
        isEInvoiceUser: true,
      })
    );
  }
  return null;
};
